import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID,
  ViewEncapsulation
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { DeviceService, IconSizeEnum, SdIconComponent } from '@seb/web-design-system/core';
import { IRecipeUser, SdRecipeUserComponent } from '@seb/web-design-system/recipe-user';

import type { ITimer } from './timer.interface';

@Component({
  selector: 'sd-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdRecipeUserComponent, SdIconComponent, TranslateModule]
})
export class SdTimerComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PLATFORM_ID) protected platformId: any,
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
  ) {}

  isDevice$: boolean;
  deviceSubscription: Subscription;
  iconSize = IconSizeEnum;

  @Input()
  isSmall = false;

  @Input()
  recipeUser: IRecipeUser;

  @Input()
  timeOverview: ITimer;

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.deviceSubscription = this.deviceService.isDevice.subscribe((x) => {
        this.isDevice$ = x;
        this.cdRef.markForCheck();
      });
    }
  }

  ngOnDestroy() {
    this.deviceSubscription?.unsubscribe();
  }
}
